module.exports = __webpack_public_path__ + "static/img/snowLotus.8a87cb0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/index/snowLotus.jpg
// module id = mGcF
// module chunks = 1